<template>
  <div>
    <Header />
    <LoadingDialog
      ref="LoadingDialog"
    />
    <v-container grid-list-md fluid class="container-style">
      <!-- FILTER/SEARCH -->
      <div class="container-header">
        <span>Payments</span>
      </div>
      <!-- TABLE -->
      <v-layout row wrap>
        <v-flex xs12>
          <div class="elevation-1">
            <v-toolbar flat color="white">
              <v-layout row wrap justify-end>
                <v-flex xs12 md4 class="box-white">
                  <v-text-field color="#091D3B" prepend-inner-icon="search" label="Search" v-model="search" box></v-text-field>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex xs12 md4 class="box-white">
                  <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                    clearable
                    v-model="date"
                    label="Filter by date"
                    prepend-inner-icon="event"
                    readonly
                    v-on="on"
                    box
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="date" @input="menu = false"></v-date-picker>
                </v-menu>
                </v-flex>
              </v-layout>
            </v-toolbar>
            <v-toolbar flat color="white">
              <v-layout row wrap class="mt-1">
                <v-flex xs12 md6>
                  <span class="title" v-if="$refs.paymentsTable"><strong>Total Amount: </strong>{{ totalAmount }} </span>
                </v-flex>
                <v-spacer></v-spacer>
                <v-btn @click="clickExportPayments" outline color="#091D3B">
                  Export
                </v-btn>
                <input v-show="false" ref="paymentsImport" type="file" @change="clickImportPayments" >
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn
                    outline color="#091D3B"
                    v-on="on">Import <v-icon dark right>mdi-chevron-down</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-tile @click="$refs.paymentsImport.click()">
                    <v-list-tile-title>Import Payments</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click="clickGenerateEnrollmentTemplate">
                    <v-list-tile-title>Download Template</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>

              <PaymentModal
              :successCallback="initialize"
              ref="PaymentModal"
              lazy
              />
              </v-layout>

            </v-toolbar>
            <v-data-table
              ref="paymentsTable"
              :headers="headers"
              :items="payments"
              :pagination.sync="pagination"
              :search="search"
              :custom-filter="customFilter"
            >
              <template v-slot:items="props">
                <td class="text-xs-left">{{ props.item.or_number_display }}</td>
                <td class="text-xs-left">{{ props.item.student_number_display }}</td>

                <td class="text-xs-left">
                  <router-link :to="{name: 'student-detail', params: {id: props.item.student_data.id}}">
                    {{ props.item.student_data.full_name }}
                  </router-link>
                </td>
                <td class="text-xs-left">{{ currencyFormat(props.item.amount) }}</td>
                <td class="text-xs-left">{{ props.item.payment_for }}</td>
                <td class="text-xs-left">{{ props.item.remarks}}</td>
                <td class="text-xs-left">{{ props.item.collected_date }}</td>
                <td>
                    <v-btn
                      @click="editPayment(props.item)"
                      color="light-gray"
                      :icon="true"
                    >
                      <v-icon
                        color="green darken-4"
                        size="15px"
                      >
                        edit
                      </v-icon>
                    </v-btn>
                </td>
              </template>
            </v-data-table>
            <v-toolbar flat color="white">
              <v-spacer></v-spacer>
              <v-btn
                class="button-style-blue"
                dark
                @click="$refs.PaymentModal.dialog = true"
              >
                Add Payment <v-icon dark right>add</v-icon>
              </v-btn>
            </v-toolbar>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import {
  mapState,
  mapActions
} from "vuex";
import {getObjectValueByPath} from 'vuetify/es5/util/helpers.js'

import Header from '@/components/Header.vue'
import PaymentModal from '@/components/PaymentModal.vue'
import LoadingDialog from '@/components/LoadingDialog.vue'

export default {
  name: "Home",
  components: {
    Header,
    PaymentModal,
    LoadingDialog,
  },
  computed: {
    ...mapState(['payments', 'payment', 'enrollment']),
    totalAmount() {
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'PHP',
        minimumFractionDigits: 2,
      });
      return (
              formatter.format(this.filteredItems.reduce((accumulator, currentValue) => accumulator + parseFloat(currentValue.amount), 0).toFixed(2))
            )
    },
  },
  data() {
    return {
      date: '',
      menu: '',
      search: '',
      filteredItems: [],
      pagination: {
        rowsPerPage: 25,
        sortBy: 'collected_date',
        descending: true,
      },
      headers: [
        {
          text: 'OR No',
          width: '10%',
          value: 'or_number_display'
        },
        {
          text: 'Student No',
          width: '10%',
          value: 'student_number_display'
        },
        {
          text: 'Name',
          width: '25%',
          value: 'student_data.full_name'
        },
        {
          text: 'Amount',
          width: '10%',
          value: 'amount'
        },
        {
          text: 'Payment For',
          width: '10%',
          value: 'payment_for'
        },
        {
          text: 'Remarks',
          width: '15%',
          sortable: false,
          value: 'remarks'
        },
        {
          text: 'Date of Payment',
          width: '15%',
          value: 'collected_date'
        },
        {
          text: '',
          sortable: false,
          width: '5%'
        }
      ],
    }
  },
  methods: {
    ...mapActions([
      'getPayments',
      'importPayments',
      'getEnrollments',
      'getEnrollmentById',
      'getPaymentByID',
    ]),
    currencyFormat (amount) {
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'PHP',
        minimumFractionDigits: 2,
      });
      return formatter.format(amount)
    },
    customFilter(items, search, filter, headers) {

      if(!this.date && !search) {
        this.filteredItems = items;
        return this.filteredItems;
      }

      const props = headers.map(h => h.value)
      items = items.filter(item => filter(item['collected_date'], this.date))
      this.filteredItems = items.filter(
        item => props.some(
          prop => {
            return filter(getObjectValueByPath(item, prop, item[prop]), search)
          }
        )
      )
      return this.filteredItems
    },
    clickGenerateEnrollmentTemplate () {
      window.open('/api/student/generate-payment-template/')
    },
    clickExportPayments () {
      if (this.date) {
        window.open('/api/payment/export-payments-excel/?filter_data='+this.date)
      } else {
        window.open('/api/payment/export-payments-excel/?filter_data=')
      }
    },
    clickImportPayments () {
      const file = this.$refs.paymentsImport.files[0]
      let formData = new FormData();
      formData.append('file', file);
      this.importPayments(formData)
        .then((data) => {
          if (data.total_added == data.total_payments) {
            this.$toastr('success', 'All payments successfully added!', '')
          } else if (data.total_added == 0) {
            this.$toastr('error', 'All payments already exist!', '')
          } else {
            this.$toastr('info', `${data.total_added} payments added and ${data.total_excluded} payments excluded!`, '')
          }
          this.$refs.paymentsImport.value = ''
          this.initialize()
        })
        .catch((error) => {
          this.$toastr(
            'error',
            'There was an issue processing your import! ' +
              'Please double-check if all the required fields ' +
              '(Collected Date, Student ID, Payment Method) are filled.',
            '',
          )
        })
    },
    editPayment(payment) {
      Promise.all([this.getEnrollmentById({id: payment.enrollment}), this.getPaymentByID(payment.id)])
        .then((data) => {
          this.$refs.PaymentModal.newPayment = this.payment
          this.$refs.PaymentModal.oldPayment = JSON.parse(JSON.stringify(this.payment))
          this.$refs.PaymentModal.selectedEnrollment = this.enrollment
          this.$refs.PaymentModal.dialog = true
        })
    },
    initialize () {
      this.getEnrollments({school_year__is_open: true})
      this.getPayments({ ordering: '-created' })
        .then(() => {
          this.filteredItems = this.payments;
        })
      
    },
  },
  created() {
    this.initialize()
  }
}
</script>
